<template>
  <section class="app-main" ref="wrap">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachePages">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  props: {
    cachePages: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    key () {
      return this.$route.path
    }
  },
  watch: {
    $route () {
      this.$refs.wrap.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  /* min-height: calc(100vh - 50px); */
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  background:rgba(248,249,253,1);
  padding: 20px 10px 0 10px;
}
.fixed-header+.app-main {
  padding-top: 110px;
  /* padding-top: 65px; */
}
</style>
